import { request } from '../request';

export default {
  // 桥页接口
  bridgePageApi: (data) => request('/api/products/pcBridgePage', 'get'),
  // 限时促销专题页 黑5网一复用
  flashSaleApi: (data) => request('/api/activity/flash_sale', 'get'),
  // 活动页面
  activePage: (data) => request('/api/public/active_page', 'get', data),
  // 周年庆活动分享领取积分
  sharePoint: (data) => request('/api/customer/share_point', 'post', data),
  //  黑5网一
  bfSignIn: () => request('/api/customer/lottery_sign_in', 'get', {}, { successMsg: true }), // 签到领积分
  lotteryDraws: () =>
    request('/api/customer/lottery_draws', 'get', {}, { successMsg: false, errorMsg: false }), // 转盘抽奖
  lotteryList: (data) => request('/api/customer/lottery_draws_log', 'get', data), // 用户的抽奖记录列表
  lotteryBroadcastList: () => request('/api/customer/lottery_draws_log_broadcast', 'get'), // 抽奖播报列表
  // 线下活动
  getReserveLog: (data) => request('/api/activity/get_event_reserve_log', 'get', data), // 查询预约记录
  onlineReserve: (data) => request('/api/activity/event_online_reserve', 'post', data), // 线下活动预约
  // 公共配置大转盘抽奖
  commonLotteryInfo: (data) => request('/api/lottery/info', 'get', data), // 通用转盘配置信息
  commonLotterySkinInfo: (data) => request('/api/lottery/skin_info', 'get', data), // 通用转盘样式配置信息
  commonLotteryDraw: (data) => request('/api/lottery/draw', 'get', data), // 通用转盘抽奖
  commonLotteryBroadcast: (data) => request('/api/lottery/broadcast', 'get', data), // 通用转盘播报列表
  commonLotteryLog: (data) => request('/api/lottery/log', 'get', data), // 通用转盘抽奖记录
  commonLotteryProtocol: (data) => request('/api/lottery/lottery_protocol', 'post', data), // 通用转盘抽奖修改协议状态
  comonLotteryCompleteTask: (data) => request('/api/activity/complete_task', 'post', data), // 通用抽奖活动-扭蛋机做任务得积分
  // 防蓝光专题页
  blueLightProduct: (data, config) => request('/api/subject/product', 'get', data, config),
  // 半框专题页
  getHalfFramePage: (data) => request('/api/activity/half_frame_page', 'get', data),
  // 新版flash-sale接口
  flashSaleInfo: (data, config) => request('/api/activity/flash_sale2', 'get', data, config),
  flashSaleCoupon: () => request('/api/activity/flash_sale_coupon', 'get'),
  // 获取2024周年庆活动页面
  get2024Anniversary: (data) =>
    request('/api/block_config/get_block_value_info', 'post', data, { errorMsg: false }),
  // 2024周年庆活动根据传入的优惠券id批量获取优惠券
  get2024AnnigetCoupons: (data) =>
    request('/api/customer/get_coupons', 'post', data, { errorMsg: false }),
  // 2024周年庆活动分享得积分
  get2024AnniPoints: () => request('/api/customer/share_point_2024', 'post', { errorMsg: false }),
  // 2024黑五活动 普通配置
  bfcmPageInfo: ({ token }) => request('/api/activity/generic_config', 'get', {}, { token }),
  // 2024黑五活动 智能推荐大数据推荐版位（like,discount）
  bfcmPageRecommend: ({ position, token }) =>
    request('/api/activity/intelligent_recommendation', 'get', { position }, { token }),
  // 2024黑五活动 分享得积分
  bfcmShare: () => request('/api/activity/share_point_for_black_friday', 'post'),
  // trend_book_quize 获取测试结果
  getRaveQuizeResult: (data) => request('/api/customer/rave_quize', 'post', data),
  // 获取营销活动埋点配置
  getAnalysisBuriedPoint: (data) => request('/api/public/analysis_buried_point', 'post', data),
  // 2025周年庆活动获取优惠券
  get2025AnnigetCoupons: (data) =>
    request('/api/customer/get_coupons_for_anniversary', 'get', data),
  // 2025周年庆活动获取优惠券升级
  get2025AnnigetCouponsUpgrade: (data) =>
    request('/api/customer/get_coupons_for_anniversary_upgrade', 'get', data),
  // tbg活动页相关接口
  tbg: {
    // 预约活动
    subscribe: (data) => request('/api/activity/reserve_activity', 'post', data),
    // 获取预约状态
    getReserveStatus: (data) =>
      request('/api/activity/get_activity_reservation_status', 'get', data),
    // 获取用户收藏的商品
    getUserHeartedProducts: () => request('/api/activity/get_all_hearted_products', 'get'),
    // 收藏状态切换
    toggleHeart: (data) => request(`/api/activity/toggle_heart/${data.product_id}`, 'post'),
    // 获取tbg活动页数据
    getTbgPageData: (data) => request('/api/subject/tbg', 'get', data),
  },
  bloodyOpium: {
    getBloodyOpiumPageData: () => request('/api/subject/bloody', 'get'),
  },
  motoBoho: {
    getMotoBohoPageData: () => request('/api/subject/moto_boho', 'get'),
  },
  visibleEngineer: {
    getVisibleEngineerPageData: () => request('/api/subject/visible_engineer', 'get'),
  },
  bfcm2025: {},
};
